"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type { BeaconRenderProps } from "react-joyride";
import { cn } from "@/lib/utils";
export function TourBeacon(t0) {
  const $ = _c(3);
  const {
    step
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("pointer-events-auto relative z-10001 inline-block size-9 rounded-full", "bg-orange shadow-md ring-4 ring-orange/35", "animate-pulse motion-reduce:animate-none");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== step.primaryColor) {
    t2 = <span className={t1} style={{
      backgroundColor: step.primaryColor
    }} />;
    $[1] = step.primaryColor;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}